import mqtt, { MqttProtocol } from 'mqtt'

const { connect } = mqtt

function uInt8ToJSON(val: Uint8Array) {
  let str = ''
  let result
  for (let i = 0; i < val.length; i++) {
    str += String.fromCharCode(val[i])
  }
  try {
    result = JSON.parse(str)
  } catch (e) {
    return null
  }
  return result
}

export class MQTTClient {
  private name: string
  private locationName: string
  private client: mqtt.MqttClient | null = null
  private callbacks: { [key: string]: (message: any, topic: string) => void } =
    {}

  constructor(name: string, locationName: string) {
    this.name = name
    this.locationName = locationName
  }

  connect(
    url: string,
    options: {
      clientId: string
      protocol: MqttProtocol | undefined
      username: string
      password: string
    },
    onConnection: (clientId: string) => void,
    error: (clientId: string, error: Error) => void,
    onClose: (clientId: string) => void
  ) {
    this.client = connect(url, options)

    const clientId = options.clientId

    this.client.on('connect', () => {
      Object.keys(this.callbacks).forEach((key) => {
        this.client?.unsubscribe(key)
        this.client?.subscribe(key)
      })
      onConnection(clientId)
    })

    this.client.on('reconnect', () => {
      onConnection(clientId)
    })

    this.client.on('close', () => onClose(clientId))
    this.client.on('offline', () => this.handleError(error, 'offline'))
    this.client.on('disconnect', (e) => {
      return this.handleError(error, 'disconnect', e)
    })

    this.client.on('error', (e) => this.handleError(error, 'error', e))
    this.client.on('message', this.handleMessage.bind(this))
  }

  private handleMessage(topic: string, message: Uint8Array) {
    if (message.length > 0) {
      const temp = uInt8ToJSON(message)
      if (this.callbacks[topic]) {
        this.callbacks[topic](temp, topic)
      }
    }
  }

  subscribe(topic: string, callback: (message: any, topic: string) => void) {
    console.log('subscribing: ', topic)
    this.client?.subscribe(topic)
    this.callbacks[topic] = callback
  }

  unsubscribe(topic: string) {
    delete this.callbacks[topic]
    this.client?.unsubscribe(topic)
  }

  endClient() {
    console.log('ending client')
    this.client?.end()
  }

  getClientId() {
    return this.client?.options.clientId
  }

  get connected() {
    return this.client?.connected ?? false
  }

  get disconnected() {
    return this.client?.disconnected ?? false
  }

  get disconnecting() {
    return this.client?.disconnecting ?? false
  }

  private handleError(
    error: (clientId: string, error: Error) => void,
    type: string,
    e?: any
  ) {
    error(this.client?.options.clientId ?? '', e)
    console.error(`MQTT ${type} error:`, e)
  }
}
